import { render, staticRenderFns } from "./filter_channel.vue?vue&type=template&id=9b909eac&scoped=true&"
import script from "./filter_channel.vue?vue&type=script&lang=js&"
export * from "./filter_channel.vue?vue&type=script&lang=js&"
import style0 from "./filter_channel.vue?vue&type=style&index=0&id=9b909eac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b909eac",
  null
  
)

export default component.exports